import React from "react";
import { Box, Typography, Container, Grid, List, ListItem, ListItemIcon, ListItemText } from "@mui/material";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import CSRImage from "../../images/tren.png"; // Replace with your actual image path

function CSRPage() {
    return (
        <Box sx={{ backgroundColor: "#f9f9f9", py: 2 }}>
            <Container>
                <Grid container spacing={4} alignItems="center">
                    {/* Left Side: Image */}
                    <Grid
                        item
                        xs={12}
                        md={6}
                        sx={{
                            position: "relative",
                            overflow: "hidden",
                            borderRadius: "12px",
                            animation: "fadeInLeft 1s ease-in-out",
                            "@keyframes fadeInLeft": {
                                "0%": { opacity: 0, transform: "translateX(-50px)" },
                                "100%": { opacity: 1, transform: "translateX(0)" },
                            },
                        }}
                    >
                        <Typography
                            variant="overline"
                            sx={{
                                fontSize: "3.4rem",
                                fontWeight: "bold",
                                letterSpacing: "0.1em",
                                color: "#C5A47E",
                            }}
                        >
                            CSR
                        </Typography>
                        <Box
                            component="img"
                            src={CSRImage}
                            alt="Responsible Tourism"
                            sx={{
                                width: "100%",
                                height: "auto",
                                borderRadius: "12px",
                                objectFit: "cover",
                            }}
                        />
                    </Grid>

                    {/* Right Side: Content */}
                    <Grid
                        item
                        xs={12}
                        md={6}
                        sx={{
                            animation: "fadeInRight 1s ease-in-out",
                            "@keyframes fadeInRight": {
                                "0%": { opacity: 0, transform: "translateX(50px)" },
                                "100%": { opacity: 1, transform: "translateX(0)" },
                            },
                        }}
                    >


                        <Typography
                            variant="h2"
                            sx={{
                                fontSize: "2rem",
                                fontWeight: "bold",
                                color: "#333",
                                mt: 1,
                                mb: 3,
                            }}
                        >
                            Responsible Tourism at Unseen Knuckles
                        </Typography>

                        <Typography
                            variant="body1"
                            sx={{
                                color: "#555",
                                lineHeight: 1,
                                mb: 3,
                            }}
                        >
                            We are deeply committed to promoting responsible tourism and sustainability.
                        </Typography>

                        {/* Bullet List */}
                        <List sx={{ mb: 1 }}>
                            <ListItem disableGutters>
                                <ListItemIcon>
                                    <FiberManualRecordIcon sx={{ fontSize: "0.75rem", color: "#C5A47E" }} />
                                </ListItemIcon>
                                <ListItemText
                                    primary="Respect Local Culture: Support local businesses and embrace cultural sensitivity."
                                    primaryTypographyProps={{ sx: { color: "#333", fontSize: "1rem" } }}
                                />
                            </ListItem>
                            <ListItem disableGutters>
                                <ListItemIcon>
                                    <FiberManualRecordIcon sx={{ fontSize: "0.75rem", color: "#C5A47E" }} />
                                </ListItemIcon>
                                <ListItemText
                                    primary="Environmental Protection: Minimize waste, conserve resources, and avoid activities harmful to wildlife."
                                    primaryTypographyProps={{ sx: { color: "#333", fontSize: "1rem" } }}
                                />
                            </ListItem>
                            <ListItem disableGutters>
                                <ListItemIcon>
                                    <FiberManualRecordIcon sx={{ fontSize: "0.75rem", color: "#C5A47E" }} />
                                </ListItemIcon>
                                <ListItemText
                                    primary="Community Engagement: Actively support and promote local economies and traditions."
                                    primaryTypographyProps={{ sx: { color: "#333", fontSize: "1rem" } }}
                                />
                            </ListItem>
                            <ListItem disableGutters>
                                <ListItemIcon>
                                    <FiberManualRecordIcon sx={{ fontSize: "0.75rem", color: "#C5A47E" }} />
                                </ListItemIcon>
                                <ListItemText
                                    primary="Education & Awareness: We provide programs that highlight the importance of environmental conservation."
                                    primaryTypographyProps={{ sx: { color: "#333", fontSize: "1rem" } }}
                                />
                            </ListItem>
                        </List>

                        {/* Closing Statement */}
                        <Typography
                            variant="h6"
                            sx={{
                                color: "#333",
                                // fontWeight: "bold",
                                mt: 2,
                                lineHeight: 1.3,
                            }}
                        >
                            At Unseen Knuckles, we believe tourism can be a force for good—uplifting communities, preserving ecosystems, and inspiring a deeper connection with the world around us.
                        </Typography>
                    </Grid>
                </Grid>
            </Container>
            <Box
                component="hr"
                sx={{
                    border: 0,
                    height: "2px",
                    backgroundColor: "#C5A47E", // Gold color
                    width: "50%", // Width of the line
                    marginTop: "60px", // Center the line
                }}
            />

        </Box>
    );
}

export default CSRPage;
